var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThenewstack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "367.308px",
    height: "44px",
    viewBox: "0 0 367.308 44",
    enableBackground: "new 0 0 367.308 44",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00AFF4",
    points: "0,0.962 0,8.546 10.796,8.546 10.796,43.113 20.15,43.113 20.15,8.546 30.719,8.546 30.719,0.962  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00AFF4",
    points: "240.737,0.962 240.737,8.546 251.535,8.546 251.535,43.113 260.886,43.113 260.886,8.546  271.454,8.546 271.454,0.962  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00AFF4",
    points: "34.156,43.113 43.627,43.113 43.627,24.828 55.387,24.828 55.387,43.113 64.741,43.113  64.741,0.885 55.214,0.885 55.214,17.244 43.568,17.244 43.568,0.885 34.156,0.885  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00AFF4",
    points: "179.114,0.885 169.702,0.885 169.702,43.113 179.143,22.825  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF3287",
    points: "179.143,22.825 179.173,43.113 189.358,21.168 189.358,0.885  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C87296",
    points: "169.702,43.113 179.173,43.113 179.143,22.825  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00AFF4",
    points: "198.769,0.885 189.358,21.168 189.358,43.113 198.798,22.825  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C87296",
    points: "189.358,0.885 189.358,21.168 198.769,0.885  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF3287",
    points: "209.013,0.885 198.798,22.825 198.828,43.113 218.424,0.885  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C87296",
    points: "189.358,43.113 198.828,43.113 198.798,22.825  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF3287",
    points: "138.471,43.035 165.013,43.035 165.013,35.452 147.825,35.452 147.825,24.828 160.931,24.828  160.931,17.244 147.71,17.244 147.71,8.546 165.013,8.546 165.013,0.962 138.471,0.962  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00AFF4",
    points: "70.463,43.035 97.004,43.035 97.004,35.452 79.818,35.452 79.818,24.828 92.924,24.828  92.924,17.244 79.703,17.244 79.703,8.546 97.004,8.546 97.004,0.962 70.463,0.962  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3287",
    d: "M102.786,43.113h8.225v-19.69c0-1.098-0.211-6.476-0.257-7.689h0.257c2.358,5.14,2.426,5.324,3.417,6.997 l10.669,20.383h7.407V0.885h-8.225V16.66c0,1.616,0,1.961,0.153,4.86l0.204,4.271h-0.249c-0.166-0.288-0.79-1.846-0.974-2.193 c-0.433-0.866-1.06-2.022-1.56-2.888L111.388,0.886h-8.601L102.786,43.113L102.786,43.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AFF4",
    d: "M277.222,0.972l-11.955,42.14h9.068l2.194-8.661h12.993l2.135,8.661h9.065l-12.241-42.14H277.222z  M287.674,27.83h-9.525l4.618-19.293h0.231L287.674,27.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AFF4",
    d: "M300.615,27.813c0,8.662,2.194,10.979,3.888,12.587c2.589,2.492,5.919,3.6,10.722,3.6 c1.809,0,6.138-0.386,9.142-2.712c3.523-2.715,4.101-5.68,4.448-7.354c0.288-1.79,0.348-2.138,0.404-5.197h-9.355 c0,4.561-1.125,7.679-4.86,7.679c-5.031,0-5.031-4.444-5.031-6.754V13.541c0-1.165,0.059-3.246,1.527-4.627 c0.955-0.868,2.406-1.33,3.563-1.33c4.629,0,4.743,4.619,4.801,6.706h9.355c-0.116-3.416-0.577-8.575-4.417-11.518 C321.835,0.509,318.014,0,315.462,0c-9.777,0-14.848,5.378-14.848,15.042V27.813z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AFF4",
    d: "M332.314,43.113h9.471V0.885h-9.471V43.113z M354.949,0.885l-12.814,20.374l14.03,21.855h11.144 l-15.07-22.547l12.935-19.681L354.949,0.885L354.949,0.885z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AFF4",
    d: "M231.091,0.962c-8.844,0-13.316,4.889-13.316,11.827c0,8.296,4.889,10.134,11.278,12.597 c7.014,2.454,8.931,3.137,8.931,6.285c0,3.829-4.013,4.744-6.247,4.744c-4.022,0-6.995-2.174-8.361-5.716l-6.468,4.745 c3.464,6.775,7.333,8.555,15.273,8.555c2.357,0,6.197-0.635,8.576-2.126c5.772-3.62,5.772-9.231,5.772-11.117 c0-3.944-1.779-6.688-2.282-7.373c-1.606-2.292-4.484-4.003-7.024-4.917l-5.939-1.945c-2.867-0.924-5.928-1.154-5.928-4.126 c0-0.444,0.117-3.552,4.792-3.851h7.382V0.962C237.529,0.962,231.651,0.962,231.091,0.962z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThenewstack);
export default __webpack_public_path__ + "static/media/thenewstack.1898959df503ff8370bbacce3dd86248.svg";
export { ForwardRef as ReactComponent };